"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const LandingStore_1 = require("../../LandingStore");
const react_redux_1 = require("react-redux");
const LandingActions_1 = require("../../LandingActions");
const emailPanel_1 = require("../../emailPanel/emailPanel");
const mapDispatchToProps = dispatch => {
    return {
        openModal: (modal, src) => dispatch(LandingActions_1.openModal(modal, src))
    };
};
class AttractLoyalLocalCustomersComponent extends React.Component {
    render() {
        return React.createElement("div", { id: "localCustomers" }, React.createElement(react_bootstrap_1.Grid, { className: "promote" }, React.createElement(react_bootstrap_1.Col, { xs: 12, md: 12, className: "text-center" }, React.createElement("img", { src: "../img/arrow_2.png", className: "img-responsive" })), React.createElement(react_bootstrap_1.Col, { xs: 12, sm: 6, className: "text-center" }, React.createElement("img", { src: "../img/home/loyalLocalCustomers/girls.png", className: "img-responsive" })), React.createElement(react_bootstrap_1.Col, { xs: 12, sm: 6, className: "attract-customers-right-part" }, React.createElement("h2", null, "Keeping Loyal Local Customers"), React.createElement("p", null, "An instant feedback program that builds and brings customers back while maintaining positive public reviews")), React.createElement(react_bootstrap_1.Col, { xs: 6, md: 6, sm: 6, className: "text-center" }, React.createElement(react_bootstrap_1.Image, { className: "video-player pointer", src: "../img/video_player.png", onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.Video);$('html, body').animate({ scrollTop: 0 });
            } }), React.createElement(emailPanel_1.default, null))));
    }
}
const AttractLoyalLocalCustomers = react_redux_1.connect(null, mapDispatchToProps)(AttractLoyalLocalCustomersComponent);
exports.default = AttractLoyalLocalCustomers;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/home/components/AttractLoyalLocalCustomers.tsx
// module id = 1109
// module chunks = 0 1